import { Button, Flex, TextField } from "@capioweb/ui-components"
import React, { useState } from "react"

interface BmiInputProps {
	length?: number
	onBmiCalculated: (length: number, weight) => void
	weight?: number
	texts: {
		length: string
		weight: string
		button: string
	}
}

export const BmiInput: React.FC<BmiInputProps> = ({
	length: initLength,
	onBmiCalculated,
	weight: initWeight,
	texts,
}) => {
	const [length, setLength] = useState<string | undefined>(
		initLength ? String(initLength) : ""
	)
	const [weight, setWeight] = useState<string | undefined>(
		initWeight ? String(initWeight) : ""
	)

	const onClick = () => {
		const lengthNumber = parseInt(length, 10)
		const weightNumber = parseInt(weight, 10)
		if (!isNaN(lengthNumber) && !isNaN(weightNumber)) {
			onBmiCalculated(lengthNumber, weightNumber)
		} else {
			// TODO: invalid input
		}
	}

	return (
		<Flex
			alignItems={{ _: "normal", l: "center" }}
			flexDirection={{ _: "column", l: "row" }}
			pb={{ _: 4.5, l: 1.5 }}
		>
			<Flex mr={{ _: 0, l: 3 }} flex={1}>
				<TextField
					label={texts.length}
					aria-label={texts.length}
					onChange={(e) => {
						setLength(e.currentTarget.value)
					}}
					value={length}
				/>
			</Flex>
			<Flex mr={{ _: 0, l: 3 }} flex={1}>
				<TextField
					label={texts.weight}
					aria-label={texts.weight}
					onChange={(e) => {
						setWeight(e.currentTarget.value)
					}}
					value={weight}
				/>
			</Flex>
			<Flex alignSelf={"center"} h={5.75}>
				<Button onClick={onClick} whiteSpace={"nowrap"}>
					{texts.button}
				</Button>
			</Flex>
		</Flex>
	)
}
